// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.provider-facebook[data-v-4e9b274e] {
	background-color: #3b5998;
}
.provider-google[data-v-4e9b274e] {
	background-color: #4285f4;
}
.provider-okta[data-v-4e9b274e] {
	background-color: #007dc1;
}
.provider-twitter[data-v-4e9b274e] {
	background-color: #000000;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
